import React from "react";
import { newContextComponents } from "@drizzle/react-components";
import { Accordion, Card, Button, ProgressBar, Table } from 'react-bootstrap';
import WhitelistForm from './WhitelistForm'
import PaymentForm from './PaymentForm'
import DatePriceProgress from './DatePriceProgress'
import Price from "./Price";
import { Web3StatusContext } from "../contexts/Web3StatusContext";
import { Trans } from 'react-i18next';

const { AccountData, ContractData, ContractForm } = newContextComponents;

class PaymentFormOrWhiteList extends React.Component {
  static contextType = Web3StatusContext;
  lastBlock = 0;

  state = {
    whitelistRegEndTimeDataKey: null,
    now: null,
  };

  componentDidMount() {
    const { drizzle } = this.props;
    const contract = drizzle.contracts.GAMEFORESTSale;

    const whitelistRegEndTimeDataKey = contract.methods["getTime"].cacheCall(0);
    
    this.setState({ whitelistRegEndTimeDataKey });
  }

  componentDidUpdate() {
    if(this.lastBlock == this.context.blockNumber)
      return;

    this.setState({now: Math.floor(Date.now() / 1000)});

    this.lastBlock = this.context.blockNumber;
  }

  // destructure drizzle and drizzleState from props
  render() {
    // get the contract state from drizzleState
    const { GAMEFORESTSale } = this.props.drizzleState.contracts;

    var whitelistRegEndTimeContract = GAMEFORESTSale["getTime"][this.state.whitelistRegEndTimeDataKey];
    
    if(whitelistRegEndTimeContract === undefined) {
      return <div><Trans>loading</Trans></div>;
    }

    var whitelistRegEndTime = parseInt(whitelistRegEndTimeContract.value);
    const nowUnix = Math.floor(Date.now() / 1000);
    
    var whiteListPeriod = nowUnix < whitelistRegEndTime;

    var paymentFormOrWhiteList = (
      <PaymentForm
        drizzle={this.props.drizzle}
        drizzleState={this.props.drizzleState}>
      </PaymentForm>);

    if(whiteListPeriod) {
      paymentFormOrWhiteList = (
        <WhitelistForm
          drizzle={this.props.drizzle}
          drizzleState={this.props.drizzleState}>
        </WhitelistForm>);
    }

    return paymentFormOrWhiteList;
  }
};

export default PaymentFormOrWhiteList;